import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SystemDashboardPage } from '@/features/dashboards/pages/SystemDashboardPage';
import { systemDashboardSearchSchema } from '@/features/dashboards/types/dashboard.types';

export const Route = createFileRoute('/_auth/dashboards/system/')({
  validateSearch: systemDashboardSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="System Dashboard">
      <Suspense fallback={<PageLoader />}>
        <SystemDashboardPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
